import React, { FC } from 'react'
import { RouteComponentProps } from 'react-router'
import { Route, Switch } from 'react-router-dom'
import { FrontUrls } from 'Src/constants/FrontUrls'
import { SuspenseComponent } from 'Modules'

const CitiesLazy = React.lazy(() => import('Pages/referenceBooks/cities/components/Cities'))
const BankLazy = React.lazy(() => import('Pages/referenceBooks/bank/components'))
const GosbLazy = React.lazy(() => import('Pages/referenceBooks/gosb/components'))
const SectorbLazy = React.lazy(() => import('Pages/referenceBooks/sector/components'))
const ChannelLazy = React.lazy(() => import('Pages/referenceBooks/channel/components'))
const StructureLazy = React.lazy(() => import('Pages/referenceBooks/structure/components'))
const SpecialOfferLazy = React.lazy(() => import('Pages/referenceBooks/specialOffer/components'))
const RegionsLazy = React.lazy(() => import('Pages/referenceBooks/regions/components'))

export const ReferenceBookRoutes: FC<RouteComponentProps> = (): JSX.Element => {
	return (
		<Switch>
			<Route
				path={FrontUrls.referenceBook.regions}
				render={(): JSX.Element => (
					<SuspenseComponent>
						<RegionsLazy />
					</SuspenseComponent>
				)}
				key={FrontUrls.referenceBook.regions}
				exact
			/>

			<Route
				path={FrontUrls.referenceBook.territorial_bank}
				render={(): JSX.Element => (
					<SuspenseComponent>
						<BankLazy />
					</SuspenseComponent>
				)}
				key={FrontUrls.referenceBook.territorial_bank}
				exact
			/>
			<Route
				path={FrontUrls.referenceBook.gosb}
				render={(): JSX.Element => (
					<SuspenseComponent>
						<GosbLazy />
					</SuspenseComponent>
				)}
				key={FrontUrls.referenceBook.gosb}
				exact
			/>
			<Route
				path={FrontUrls.referenceBook.sector}
				render={(): JSX.Element => (
					<SuspenseComponent>
						<SectorbLazy />
					</SuspenseComponent>
				)}
				key={FrontUrls.referenceBook.sector}
				exact
			/>
			<Route
				path={FrontUrls.referenceBook.channel}
				render={(): JSX.Element => (
					<SuspenseComponent>
						<ChannelLazy />
					</SuspenseComponent>
				)}
				key={FrontUrls.referenceBook.channel}
				exact
			/>
			<Route
				path={FrontUrls.referenceBook.channel_structure}
				render={(): JSX.Element => (
					<SuspenseComponent>
						<StructureLazy />
					</SuspenseComponent>
				)}
				key={FrontUrls.referenceBook.channel_structure}
				exact
			/>
			<Route
				path={FrontUrls.referenceBook.special_offers}
				render={(): JSX.Element => (
					<SuspenseComponent>
						<SpecialOfferLazy />
					</SuspenseComponent>
				)}
				key={FrontUrls.referenceBook.special_offers}
				exact
			/>
			<Route
				exact
				path={FrontUrls.referenceBook.cities}
				render={(): JSX.Element => (
					<SuspenseComponent>
						<CitiesLazy />
					</SuspenseComponent>
				)}
				key={FrontUrls.referenceBook.cities}
			/>
		</Switch>
	)
}
